import React, { useContext, lazy, Suspense, useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import SimpleContext from "../context/SimpleContext";
import BasketInfo from "./BasketInfo";
import Preloader from "../Preloader/preloader";
import MyModal from "../common/Modal/MyModal";
import config from "../../services/config.json";
import { useHistory } from "react-router";
import { browserName, browserVersion } from "react-device-detect";
const CartItems = lazy(() => {
  return new Promise((resolve) => setTimeout(resolve, 1000)).then(() =>
    import("./CartItems")
  );
});

const SecondBasketsHeader = lazy(() => {
  return new Promise((resolve) => setTimeout(resolve, 1000)).then(() =>
    import("./SecondBasketsHeader")
  );
});

const Shop = () => {
  const stylee = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "#ff7014",
  };
  const context = useContext(SimpleContext);
  const [exitNextBasketModal, setexitNextBasketModal] = useState(false);
  const [deleteNextBasketModal, setdeleteNextBasketModal] = useState(false);
  const [loader, setlodaer] = useState(false);
  const history = useHistory();

  useEffect(() => {
    context.loadBasket();
  }, []);

  const sendToNextBasket = () => {
    context.setbasketloader(true);
    async function FinalPost() {
      let MyTime = Date.now();
      let TimeHeader = context.Encriptor(context.timeMiliSecondDef + MyTime);
      const myheaders = {
        "atu-token": TimeHeader,
      };
      const url = `${context.baseUrlApiPakhsh}${config.basketModify}`;
      const data = {
        mobile: context.phone,
        basketType: context.AppType,
        customerId:
          Object.values(context.UseInFo).length > 0 &&
          context.UseInFo.customerId,
        appVersion: browserName,
        AndroidVersion: browserVersion,
        deviceId: context.UniqueUUID,
        rows: context.MyBasketItems,
        addressID:
          context.MyDefaultAddress === undefined
            ? 0
            : context.MyDefaultAddress.addressId,
      };
      const param = {
        method: "Post",
        body: JSON.stringify(data),
        headers: myheaders,
      };
      const sendRequestSabt = await fetch(url, param);
      const responseSabt = await sendRequestSabt.json();
      return responseSabt;
    }
    try {
      FinalPost().then((data) => {
        if (parseInt(data.code) === 200) {
          context.loadBasket(1);
        } else if (parseInt(data.code) === 401) {
          context.setshowModalTime(true);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  const deleteFromBasket = async () => {
    context.setbasketloader(true);
    setlodaer(true);
    async function FinalPost() {
      let MyTime = Date.now();
      let TimeHeader = context.Encriptor(context.timeMiliSecondDef + MyTime);
      const myheaders = {
        "atu-token": TimeHeader,
      };
      const url = `${context.baseUrlApiPakhsh}${config.deleteFromCart}`;
      const data = context.MyBasketItems;
      const param = {
        method: "Post",
        body: JSON.stringify(data),
        headers: myheaders,
      };
      const sendRequestSabt = await fetch(url, param);
      const responseSabt = await sendRequestSabt.json();
      return responseSabt;
    }
    try {
      await FinalPost().then((data) => {
        if (parseInt(data.code) === 200) {
          setlodaer(false);
          context.loadBasket(1);
          context.handlecountBasketItems();
        } else if (parseInt(data.code) === 401) {
          context.setshowModalTime(true);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  function handleGoToNext() {
    history.push("/nextbasket");
  }

  return (
    <>
      {context.showPre === true ? (
        <>
          <Preloader />
        </>
      ) : (
        <>
          <div style={{ marginTop: "60px" }} className="MainMyApi">
            {context.basketloader === true ? (
              <Preloader />
            ) : (
              <>
                {/* <div className="Header">
                <Row
                  className="HeaderRow"
                  style={{ borderBottom: "0.5px solid #e5e5e5" }}
                >
                  <Col className="HeaderCols2" style={stylee}>
                    <h1
                      style={{
                        fontWeight: "bold",
                        color: "rgb(133 131 131)",
                        fontSize: "14px",
                      }}
                    >
                      سبد خرید
                    </h1>
                  </Col>

                  <Col
                    onClick={() => handleGoToNext()}
                    className="HeaderCols2"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <h1
                      style={{
                        fontWeight: "bold",
                        color: "rgb(133 131 131)",
                        fontSize: "14px",
                      }}
                    >
                      لیست خرید بعدی
                    </h1>
                  </Col>
                </Row>
              </div> */}
                <div className="BasketMain">
                  {/* <Suspense style={{ fontWeight: "bold", color: "black" }}>
                  <SecondBasketsHeader
                    left="حذف همه"
                    right="ذخیره همه برای خرید بعدی"
                    setexitNextBasketModal={setexitNextBasketModal}
                    setdeleteNextBasketModal={setdeleteNextBasketModal}
                  />
                </Suspense>  */}
                  {/* {
                  
                  Object.values(context.FirstBasket).length > 0 ? (
                    context.FirstBasket.basketRows.length===0?
                    <h1>
                      لیست سبد خرید شما خالی
                    </h1>
                } */}
                  <div className="BasketMain2">
                    <Suspense>
                      <CartItems />
                    </Suspense>
                  </div>
                </div>
              </>
            )}
            <Modal
              show={exitNextBasketModal}
              style={{ marginTop: "50%" }}
              className="MyModal"
            >
              <MyModal
                img={"/images/ic_change_basket.png"}
                setexitModal={setexitNextBasketModal}
                txt={`تمام کالاها به سبد خرید بعدی منتقل میشود. مطمئن هستید؟ `}
                action={() => sendToNextBasket()}
              />
            </Modal>
            <Modal
              show={deleteNextBasketModal}
              style={{ marginTop: "50%" }}
              className="MyModal"
            >
              <MyModal
                img={"/images/ic_delete_basket.png"}
                setexitModal={setdeleteNextBasketModal}
                txt={`تمام کالاها حذف میشود. مطمئن هستید؟ `}
                action={() => deleteFromBasket()}
              />
            </Modal>
          </div>
        </>
      )}
    </>
  );
};

export default Shop;
